import { Link } from 'react-router-dom';

import { formatDate } from '../../../utils/formatUtils';
import ComponentWithTooltip from '../../ComponentWithTooltip/ComponentWithTooltip';
import { assignmentTypeEnum } from '../../../utils/dataStatus';

const showEventAndDates = ({ row }) => {
  const event = row.original.evento;

  return (
    <ComponentWithTooltip tooltipText={event}>
      <p>{event}</p>
    </ComponentWithTooltip>
  );
};

export const toUrl = ({ tipoAsignacionEnum, idSolicitud }) => {
  if (tipoAsignacionEnum === assignmentTypeEnum.Mensualizada) {
    return `/detailmonthly/${idSolicitud}`;
  }

  return `/detail/${idSolicitud}`;
};
const linkSDS = ({ value, cell }) => (
  <div className="d-flex justify-content-between align-items-center">
    <Link
      style={{
        textDecoration: 'none',
        color: '#0063bd'
      }}
      target="_blank"
      to={toUrl(cell.row.original)}
    >
      {value}
    </Link>
  </div>
);

const columns = [
  {
    Header: 'Proveedor Contrato',
    accessor: 'proveedorContrato',
    hideSort: true
  },
  { Header: 'Ubicación', accessor: 'ubicacion', hideSort: true },
  {
    Header: 'Probable R.',
    accessor: 'fechaProbableRealizacion',
    Cell: formatDate,
    hideSort: true
  },
  {
    Header: 'Evento',
    accesor: 'evento',
    hideSort: true,
    Cell: showEventAndDates
  },
  {
    Header: 'Solicitud',
    accessor: 'numeroSolicitud',
    hideSort: true,
    Cell: linkSDS
  },
  {
    Header: 'Servicio',
    accessor: 'servicio',
    hideSort: true
  },
  {
    Header: 'Obj. Imp.',
    accessor: 'objetoImputacion',
    hideSort: true
  }
];

export default columns;
